import {Melody} from "../model/melody";
import {environment} from "../../environments/environment";
import {Artist} from "../model/artist";
import {SubscriberMelody} from "../model/subscriber-melody";
import {constants} from "../constants";

export const updateMelodiesPaths = (melodies: readonly Melody[]) => {
  melodies.forEach(updateMelodyPaths);

  return melodies;
};

export const updateMelodyPaths = (melody: Melody) => {
  if (melody.pictureUrl) {
    melody.pictureUrl = environment.contentPrefix + melody.pictureUrl;
  }
  if (melody.pictureUrlSmall) {
    melody.pictureUrlSmall = environment.contentPrefix + melody.pictureUrlSmall;
  }
  if (melody.pictureUrlBig) {
    melody.pictureUrlBig = environment.contentPrefix + melody.pictureUrlBig;
  }
  melody.mp3Path = environment.contentPrefix + melody.mp3Path;

  return melody;
};

export const updateArtistsPaths = (artists: readonly Artist[]) => {
  artists.forEach(updateArtistPaths);

  return artists;
};

export const updateArtistPaths = (artist: Artist) => {
  if (artist.pictureUrl) {
    artist.pictureUrl = environment.contentPrefix + artist.pictureUrl;
  }

  return artist;
};

export const updateSubscriberMelodiesPaths = (melodies: readonly SubscriberMelody[]) => {
  melodies.forEach(updateSubscriberMelodyPaths);

  return melodies;
};

export const updateSubscriberMelodyPaths = (melody: SubscriberMelody) => {
  if (melody.pictureUrlSmall) {
    melody.pictureUrlSmall = environment.contentPrefix + melody.pictureUrlSmall;
  } else {
    melody.pictureUrlSmall = constants.defaultImage;
  }
  if (melody.mp3Path) {
    melody.mp3Path = environment.contentPrefix + melody.mp3Path;
  }

  if (melody.rbtCode == '-2') {
    melody.pictureUrlSmall = constants.gudokImage;
  }

  return melody;
};
